import {PropsData} from '../../../../_metronic/partials'
import React, {FC} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

type PropsSatisfaction = {
  field: string,
  stars: PropsData,
}
const SatisfactionForm: FC<PropsSatisfaction> = ({field, stars}) => {

  return (
    <>
      <div className="row mb-7">
        <label className="col-lg-4 fw-bold text-muted text-capitalize">{field}</label>
        <div className="col-lg-8 fv-row">

                <span className="fw-bold fs-6">
                    {
                      !stars.arrayStar.length
                        ? <span className="fw-bold fs-6">{stars.value}</span>
                        : stars.arrayStar.map((star, index) => (
                          <KTSVG key={index}
                                 path={'/media/icons/duotune/general/gen029.svg'}
                                 className={`svg-icon-2 svg-icon-${star.color}`}
                          />
                        ))
                    }
                </span>
        </div>
      </div>
    </>
  )
}

export {SatisfactionForm}